import { render, staticRenderFns } from "./qs.vue?vue&type=template&id=5879834f&scoped=true"
import script from "./qs.vue?vue&type=script&lang=js"
export * from "./qs.vue?vue&type=script&lang=js"
import style0 from "./qs.vue?vue&type=style&index=0&id=5879834f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5879834f",
  null
  
)

export default component.exports